import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { saveNewForm, formDetails as updateFormDetails } from 'utils/urls';

import { Forms } from 'types/forms';
import { ErrorModal } from 'types/modalTypes';

export async function postForm(params: Forms): Promise<TResult> {
  const { AccountId, Id } = params;
  const response = await fetch(
    Id === 0 ? saveNewForm(AccountId) : updateFormDetails(AccountId, Id),
    {
      method: Id === 0 ? 'POST' : 'PUT',
      headers: {
        Authorization: getTokenWithType(),
        'content-type': 'application/json',
      },
      body: JSON.stringify(params),
    },
  );
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Forms;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = Forms;

type TSnapshot = unknown;

function useSaveForm(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: Forms) => {
    const newForm = await postForm(params);
    if (newForm.StatusCode === 200 || newForm.StatusCode === 201) {
      queryClient.invalidateQueries([
        'get_form_details',
        params.AccountId,
        params.Id,
      ]);
      queryClient.invalidateQueries(['forms_list']);
    } else if (newForm?.Errors[0]) throw newForm;
    return newForm;
  });
}

export { useSaveForm };
